export const isUrlToPdf = (url: string) => /\.pdf$/.test(url);
